import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Close } from '../assets/closeBtn.svg';
import axios from 'axios';
import config from "../config";
import { useSelector } from 'react-redux';
import LoaderInside from './LoaderInside';

const GENDER_TYPES = {
    MALE: 'Мужской',
    FEMALE: 'Женский'
};

const GuideDetailPage = () => {
    const { title, buttonText } = useParams();
    const navigate = useNavigate();
    const [imageUrl, setImageUrl] = useState('');
    const [guideTitle, setGuideTitle] = useState('');
    const [guideText, setGuideText] = useState('');
    const [buttonUrl, setButtonUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const adminMode = useSelector((state) => state.adminMode.adminMode);
    const reduxGender = useSelector((state) => state.user.gender);
    const [selectedGender, setSelectedGender] = useState(reduxGender || GENDER_TYPES.MALE);
    const initData = window.Telegram.WebApp.initData;

    // Определяем, какой пол использовать для запросов
    const genderToUse = adminMode ? selectedGender : reduxGender;

    const handleSave = () => {
        const dataToSend = {
            title,
            initData,
            buttonText,
            imageUrl,
            guideTitle,
            guideText,
            buttonUrl,
            gender: genderToUse
        };

        axios.post(`${config.API_BASE_URL}/upgrade/save-guide`, dataToSend)
            .then((response) => {
                if (response.data.success) {
                    alert('Данные сохранены');
                } else {
                    alert('Ошибка сохранения');
                }
            })
            .catch(() => alert('Ошибка при сохранении данных'));
    };

    const handleClose = () => {
        navigate(`/upgrade/${encodeURIComponent(title)}`);
    };

    useEffect(() => {
        axios.get(`${config.API_BASE_URL}/upgrade/get-guide?title=${title}&button=${buttonText}&gender=${genderToUse}`)
            .then(({ data }) => {
                if (data.success) {
                    setImageUrl(data.imageUrl || '');
                    setGuideTitle(data.guideTitle || '');
                    setGuideText(data.guideText || '');
                    setButtonUrl(data.buttonUrl || '');
                } else {
                    console.error('Ошибка загрузки данных гайда:', data);
                }
            })
            .catch(() => console.error('Ошибка при запросе данных гайда'))
            .finally(() => setIsLoading(false));
    }, [title, buttonText, genderToUse]);

    if (isLoading) {
        return <div className="main-load"><LoaderInside /></div>;
    }

    return (
        <div className="guide-detail-page">
            <div className='detail-head'>
                <div className="close-btn" onClick={handleClose}>
                    <Close />
                </div>
                <h2>{title}</h2>
            </div>
            <div className="guide-detail-content">
                {adminMode ? (
                    <div className="admin-guide-form">
                        <div className="form-group">
                            <label>Ссылка на изображение:</label>
                            <input
                                className='input'
                                type="text"
                                value={imageUrl}
                                onChange={(e) => setImageUrl(e.target.value)}
                                placeholder="Ссылка на изображение"
                            />
                        </div>

                        <div className="form-group">
                            <label>Заголовок гайда:</label>
                            <input
                                className='input'
                                type="text"
                                value={guideTitle}
                                onChange={(e) => setGuideTitle(e.target.value)}
                                placeholder="Заголовок гайда"
                            />
                        </div>

                        <div className="form-group">
                            <label>Текст гайда:</label>
                            <textarea
                                className='textarea'
                                value={guideText}
                                onChange={(e) => setGuideText(e.target.value)}
                                placeholder="Текст гайда"
                            />
                        </div>

                        <div className="form-group">
                            <label>Ссылка для кнопки:</label>
                            <input
                                className='input'
                                type="text"
                                value={buttonUrl}
                                onChange={(e) => setButtonUrl(e.target.value)}
                                placeholder="Ссылка для кнопки"
                            />
                        </div>

                        <button className="button-sv" onClick={handleSave}>Сохранить</button>
                    </div>
                ) : (
                    <div className="user-guide-view">
                        {imageUrl && (
                            <div className="guide-image-container">
                                <img src={imageUrl} alt="Изображение гайда" />
                            </div>
                        )}

                        {guideTitle && <h3 className="guide-title">{guideTitle}</h3>}

                        {guideText && <div className="guide-text">{guideText}</div>}

                        {buttonUrl && (
                            <div className="guide-button-container">
                                <a href={buttonUrl} target="_blank" rel="noopener noreferrer" className="guide-button">
                                    Подробнее
                                </a>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GuideDetailPage; 